module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "media-list"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("学员管理")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tableList"
  }, [_c('queryStuBar', {
    ref: "refquery",
    on: {
      "queryResult": _vm.queryHandle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addStu
    }
  }, [_vm._v("增加学员")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "document"
    },
    on: {
      "click": _vm.multyImport
    }
  }, [_vm._v("批量导入")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    attrs: {
      "data": _vm.queryData,
      "header-cell-style": _vm.rowClass,
      "tooltip-effect": "dark",
      "id": "Table"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "学员ID",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewStu(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "学员昵称",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewStu(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "weixinId",
      "label": "微信号",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "家长手机号",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.filterByPhone(scope.row.phone)
            }
          }
        }, [_vm._v(_vm._s(scope.row.phone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "signupDate",
      "label": "报名时间",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "会员有效期",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          scope.row.expireDate == '2121-01-01' ||
          scope.row.expireDate == null
        ) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("永久有效")]) : _c('span', [_vm._v(_vm._s(_vm.checkTime(scope.row.expireDate) ?
          scope.row.expireDate :
          "已过期") + "\n            " + _vm._s(scope.row.expireTag) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "学生状态",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("注册")]) : (scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("激活")]) : (scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("活跃")]) : (scope.row.status == 3) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("到期")]) : (scope.row.status == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("注销")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": "",
      "align": "center",
      "width": "240",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "编辑",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "关联信息",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-warning"
          },
          on: {
            "click": function($event) {
              return _vm.viewStu(scope.row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "操作日志",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-document"
          },
          on: {
            "click": function($event) {
              return _vm.historyStu(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnFlex bottomOperBtn",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "delete2"
    },
    on: {
      "click": function($event) {
        return _vm.opStu('delete')
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "star-on"
    },
    on: {
      "click": function($event) {
        return _vm.opStu('active')
      }
    }
  }, [_vm._v("激活")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "caret-bottom"
    },
    on: {
      "click": function($event) {
        return _vm.opStu('logout')
      }
    }
  }, [_vm._v("注销")]), _vm._v(" "), _c('stuAddExtra', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "len": _vm.multipleSelection.length
    },
    on: {
      "extraResult": _vm.addExtraHandle
    }
  }), _vm._v(" "), _c('stuChgExpire', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "len": _vm.multipleSelection.length
    },
    on: {
      "chgExpire": _vm.chgExpireHandle
    }
  }, [_vm._v("修改会员有效期")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "960",
      "footer-hide": ""
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center",
      "font-size": "15px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("资源列表文件格式样例")])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable2",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px",
      "font-size": "10px"
    },
    attrs: {
      "data": _vm.showData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_vm._v("\n      \" >\n      "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "*学员ID",
      "align": "center",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "*学员昵称",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "*电话",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "*性别",
      "align": "center",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birthday",
      "label": "*出生日期",
      "align": "center",
      "width": "105"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "signupTIme",
      "label": "*报名日期",
      "align": "center",
      "width": "105"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "weixinId",
      "label": "微信号",
      "align": "center",
      "width": "105"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "effect",
      "label": "*学员有效期",
      "align": "center",
      "min-width": "105"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "className",
      "label": "班级名称",
      "align": "center",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jionTime",
      "label": "入班时间",
      "align": "center",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rateTeacherId",
      "label": "定级老师",
      "align": "center",
      "width": "105"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("（1）样例中的所有列必须按顺序全部存在")]), _vm._v(" "), _c('p', [_vm._v("（2）加*为必填项")]), _vm._v(" "), _c('p', [_vm._v("（3）学员id为0表示新增，非0为编辑")]), _vm._v(" "), _c('p', [_vm._v("（4）excel格式为xlsx")]), _vm._v(" "), _c('el-upload', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "action": "/edu/eduAdmin/stu/import",
      "accept": ".xlsx, .xls",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUpload,
      "on-error": _vm.onErrorUpload,
      "data": _vm.uploadData,
      "show-file-list": true
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n        立即导入\n        "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1), _vm._v(" "), (_vm.uploadResult != null) ? _c('div', [_c('p', [_vm._v("导入学员总数:" + _vm._s(_vm.uploadResult.total))]), _vm._v(" "), _c('p', [_vm._v("导入成功数量:" + _vm._s(_vm.uploadResult.succ))]), _vm._v(" "), _c('p', [_vm._v("导入失败数量:" + _vm._s(_vm.uploadResult.fail))]), _vm._v(" "), (_vm.uploadResult.succ != 0) ? _c('p', {
    staticStyle: {
      "color": "red",
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        注：表格中第" + _vm._s(_vm.uploadResult.succ + 1) + "行之前数据已经导入成功，请勿重复导入，再次上传请在表格中删除！\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.badResult != null) ? _c('el-table', {
    ref: "multipleTable2",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px",
      "font-size": "10px"
    },
    attrs: {
      "data": _vm.badResult,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "row",
      "label": "行数",
      "align": "center",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "field",
      "label": "出错字段",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reason",
      "label": "出错原因",
      "align": "center"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "470",
      "footer-hide": ""
    },
    model: {
      value: (_vm.logoutShow),
      callback: function($$v) {
        _vm.logoutShow = $$v
      },
      expression: "logoutShow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "15px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("需要清除的数据")])], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formStu,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.formStu.deleteOptions),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "deleteOptions", $$v)
      },
      expression: "formStu.deleteOptions"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "course"
    }
  }, [_vm._v("班级关联课程")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "extraCourse"
    }
  }, [_vm._v("特色课程")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "studyRecord"
    }
  }, [_vm._v("学习记录")]), _vm._v(" "), _c('br')], 1)], 1)], 1), _vm._v(" "), _c('Divider'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "276px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalConfirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalCancel
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21ddf9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/stu/stuList.vue
// module id = 664
// module chunks = 1